import {
  createConfig,
  deleteConfig,
  getConfig,
  getConfigByTypeKey,
  getConfigs,
  updateConfig,
} from "./configurationService";

const TYPE = "systemSetting";
const viewScope = [
  "owner",
  "admin",
  "prompt-engineer",
  "clinical-author",
  "demonstrator",
  "viewer",
];
const editScope = ["owner", "admin"];
const deleteScope = ["owner", "admin"];

const locks = {};

export const systemSettingsService = {
  initialize: async (initialData) => {
    try {
      for (const setting of initialData) {
        const exist = await systemSettingsService.getByKey(setting.key);
        if (exist) {
          continue;
        }
        await systemSettingsService.create({
          key: setting.key,
          value: {
            name: setting.name,
            description: setting.description,
            content: setting.content,
            format: setting.format,
          },
        });
      }
      return await systemSettingsService.list();
    } catch (exception) {
      console.error("Initialization error:", exception);
      return [];
    }
  },
  create: async ({ key, value }) => {
    if (locks[key]) {
      return;
    }
    try {
      locks[key] = true;
      const data = await createConfig(
        TYPE,
        key,
        JSON.stringify(value),
        null,
        null,
        viewScope,
        editScope,
        deleteScope,
      );
      return {
        ...value,
        id: data.id,
        key: data.key,
      };
    } finally {
      delete locks[key];
    }
  },
  list: async () => {
    const results = await getConfigs(TYPE);
    const items =
      results.map((result) => {
        let value = JSON.parse(result.value);
        if (typeof value === "string") {
          value = { name: value };
        }
        value.id = result.id;
        value.key = result.key;
        value.updated_by = result.updated_by;
        value.updated_at = result.updated_at;
        return value;
      }) ?? [];
    return items.sort((a, b) => a.name.localeCompare(b.name));
  },
  getById: async (id, throw404 = false) => {
    try {
      const result = await getConfig(id);
      const value = JSON.parse(result.value);
      value.id = result.id;
      value.key = result.key;
      value.updated_by = result.updated_by;
      value.updated_at = result.updated_at;
      return value;
    } catch (e) {
      if (throw404 && e.response && e.response.status === 404) {
        throw e;
      }
    }
    return null;
  },
  getByKey: async (key, throw404 = false) => {
    try {
      const result = await getConfigByTypeKey(TYPE, key);
      const value = JSON.parse(result.value);
      value.id = result.id;
      value.key = result.key;
      value.updated_by = result.updated_by;
      value.updated_at = result.updated_at;
      return value;
    } catch (e) {
      if (throw404 && e.response && e.response.status === 404) {
        throw e;
      }
    }
    return null;
  },
  update: async ({ id, value }) => {
    const existing = await systemSettingsService.getById(id);
    if (!existing) {
      throw new Error("Setting does not exist");
    }
    const key = value.key ? value.key : existing.key;
    return await updateConfig(id, TYPE, key, JSON.stringify(value));
  },
  delete: async (id) => {
    return await deleteConfig(id);
  },
};

export default systemSettingsService;
